export const environment = {
  production: true,
  apiUrl: 'https://i40test.servizi.mquadro.net/api/v1',
};
//apiUrl: 'https://i40test.servizi.mquadro.net/api/v1',
//apiUrl: 'https://i40testbeta.servizi.mquadro.net/api/v1',